/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface JobStatusResponse
 */
export interface JobStatusResponse {
    /**
     * Overall job status. SUCCESS when all credit jobs and moneytree accounts are successful, EXPIRING when at least one access token connected by credit is expiring within 7 days, FAILURE when at least one credit job or moneytree account is failed, NOT_CONNECTED when there are no connected accounts
     * @type {string}
     * @memberof JobStatusResponse
     */
    'status': JobStatusResponseStatusEnum;
}

export const JobStatusResponseStatusEnum = {
    success: 'SUCCESS',
    failure: 'FAILURE',
    expiring: 'EXPIRING',
    expired: 'EXPIRED',
    notConnected: 'NOT_CONNECTED'
} as const;

export type JobStatusResponseStatusEnum = typeof JobStatusResponseStatusEnum[keyof typeof JobStatusResponseStatusEnum];


